module.exports = __webpack_public_path__ + "480e31404574d355154d7da59e109d79.pdf";